import VerificationCode from "../components/forms/VerificationCode";
import { useLocation } from "@solidjs/router";
import { verifyUser, resendCode } from "../services/registerService";
import { useNavigate } from "@solidjs/router";
import { createSignal } from "solid-js";
import Loading from "../components/Loading";

export default function TwoFactor() {
  const location = useLocation();
  const email = location.state?.email;
  const nav = useNavigate();
  const [resetCount, setResetCount] = createSignal(0);
  const [isVerified, setIsVerified] = createSignal(false);
  const [loading, setLoading] = createSignal(false);

  const handleVerify = async (code) => {
    try {
      setLoading(true);
      const verified = await verifyUser(email, code);
      if (verified) {
        setLoading(false);
        setIsVerified(true);
        setTimeout(() => {
          nav("/");
        }, 1000);
      } else {
        setLoading(false);
        console.log("wrong code");
        setResetCount((c) => c + 1);
      }
    } catch (e) {
      setLoading(false);
      console.log(e);
      console.log("error");
      setResetCount((c) => c + 1);
    }
  };

  return (
    <div class="page">
      <Show
        when={!isVerified()}
        fallback={
          <div class="two-factor-div">
            <p style="font-size: 1.8em;">Account Verified!</p>
          </div>
        }>
        <div class="logo-container">
          <h1>mia</h1>
        </div>
        <div class="two-factor-div">
          <h2 style="margin-bottom: 0;">Check your email</h2>
          <p class="confirmation-message" style="color: #878787; margin-top: 0">
            We sent a 6-digit code to {email}. Enter it below to finish creating
            your account.
          </p>
          <VerificationCode
            onComplete={handleVerify}
            resetCount={resetCount()}></VerificationCode>
          <p style="color: #878787; margin-top: 0;">
            Didn't receive a code?{" "}
            <span
              style={{ "text-decoration": "underline", cursor: "pointer" }}
              onClick={() => resendCode(email)}>
              Resend code
            </span>
          </p>
        </div>
      </Show>
      <Loading show={loading()} />
    </div>
  );
}
